import * as B from '../../BountyDetailParts'

export const BountyDetailLive = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        <B.StatusCard mb="$4">
          <B.StatusHeading>Live</B.StatusHeading>
          <B.StatusParagraph>Woohoo! You're earning bounty.</B.StatusParagraph>
        </B.StatusCard>
        <B.LiveVideoPreview />
      </B.SectionGroup>
      <B.OrderDetails />
    </B.Page>
  )
}
